import AbstractFilter from './AbstractFilter';

export default class ToNull extends AbstractFilter
{
    filter(value: any): any
    {
        if(('number' === typeof value || 'bigint' === typeof value) && 0 === value)
        {
            return null;
        }
        else if('string' === typeof value && ('0' === value || '' === value))
        {
            return null;
        }
        else if(Array.isArray(value) && 0 === value.length)
        {
            return null;
        }
        else if('boolean' === typeof value && !value)
        {
            return null;
        }

        return value;
    }
}